/* Copyright (c) 2020-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Span, Tracer } from '@opentelemetry/api';

export type OpenTelemetrySpan = Span;
export type OpenTelemetryTracer = Tracer;

export interface HttpPopupErrorDetails {
    errorCode: string;
    errorText: string;
    failedUrl: string;
}

export interface OTELTracerConfiguration {
    exportConfig: OTELExportConfig;
    apiTracingConfig?: APITracingConfig;
}

export interface OTELExportConfig {
    collectorUrl: string;
    accessToken: string;
    componentName: string;
    collectorEndpoint?: string;
}

export interface APITracingConfig {
    urlRegex: string[];
    /** Query parameter names omitted from XHR span attributes and event URLs. */
    excludedQueryParams?: string[];
}

export interface SpanTags {
    [key: string]: any;
}

export const LightStepTokenHeader = 'Lightstep-Access-Token';
